import { getCellIds } from "./../helpers/main";
import { IAction, IActionConfig, ISpan } from "./../types";
import { updateSpans } from "../helpers/actions";

export class AddRow implements IAction {
	public config: IActionConfig;
	private _index: number;
	private _sheetName: string;
	private _prev: { rows: { height: number }[]; merged?: ISpan[] };

	constructor(config: IActionConfig) {
		this.config = config;
		this._sheetName = config.spreadsheet?.getActiveSheet().name as string;
	}

	do() {
		const { cell, grid, dataStore, spreadsheet } = this.config;
		if (!cell) return;
		if (!this._index) {
			this._index = getCellIds(cell, grid).row;
		}
		const activePage = dataStore.getPage(this._sheetName);
		activePage.addRow(this._index, 1);
		const { rows, merged = [] } = activePage.getMeta();
		this._prev = { rows: [...rows] };
		const rowsBefore = rows.slice(0, this._index);
		const rowsAfter = rows.slice(this._index);
		activePage.setMeta({
			rows: [...rowsBefore, { height: grid?.config.rowHeight }, ...rowsAfter],
		});

		(spreadsheet as any)._updateGridSizes();
		const spans = updateSpans(0, 1, this._index, activePage);
		if (spans) {
			this._prev.merged = [...merged];
			(spreadsheet as any)._updateGridState();
		}
	}

	undo() {
		const { dataStore, spreadsheet } = this.config;
		const activePage = dataStore.getPage(this._sheetName);
		activePage.removeRow(this._index, 1);
		activePage.setMeta(this._prev);
		(spreadsheet as any)._updateGridSizes();
		if (this._prev.merged) {
			(spreadsheet as any)._updateGridState();
		}
	
	}
}
